import { useEffect, useState } from 'react';
import { PrimeReactProvider } from 'primereact';
import { ThemeContext } from '../Contexts';
import { useApp, useAuthentication } from '../Hooks';
export function ThemeProvider({ children }) {
    const MAX_HEIGHT_HEADER = "71px";
    const defaultVendorTheme = "generico";
    const defaultThemes = {
        generico: {
            title: "ERP",
            color1: "black",
            color2: "black",
            color3: "black",
            color1T: "",
            logo: "",
            favicon: "",
            MAX_HEIGHT_HEADER,
        },
        claro: {
            title: "GN ERP",
            color1: "#D52B1E",
            color2: "#1097AF",
            color3: "#FFFFFF",
            color1T: "",
            MAX_HEIGHT_HEADER,
            skeletonColor: "#D5D8DC",
        },
        citrus: {
            title: "Citrus ERP",
            color1: "#F16101",
            color2: "#8AA8B0",
            color3: "#FFFFFF",
            color1T: "",
            MAX_HEIGHT_HEADER,
            skeletonColor: "#D5D8DC",
        },
    };

    const { configuration } = useApp();
    const { usuario } = !window.location.pathname.includes("login.aspx") ? useAuthentication() : {usuario: null};
    const [theme, setTheme] = useState(
        defaultThemes[configuration?.Vendor || defaultVendorTheme]
    );
    const [vendorTheme, setVendorTheme] = useState(
        defaultThemes[defaultVendorTheme]
    );

    const [pt, setPt] = useState(null);
    
    useEffect(() => {
        let newVendorTheme =
            defaultThemes[configuration?.Vendor || defaultVendorTheme];

        let newTheme = !usuario
            ? newVendorTheme
            : {
                ...newVendorTheme,
                color1: "#" + usuario?.Compania.Color1,
                color2: "#" + usuario?.Compania.Color2,
                color3: "#" + usuario?.Compania.Color3,
                color1T: usuario?.Compania.Color1T,
                MAX_HEIGHT_HEADER,
            };

        setPt({
            global: {
                css: `
                .p-selectbutton .p-button:not(.p-disabled):not(.p-highlight):hover {
                    background: ${newTheme.color1T} !important;
                }
            `
            }            
        })
        
        setVendorTheme(newTheme);
        setTheme(newTheme);
        updateTitle(theme.title);
    }, [usuario, configuration]);

    const updateTitle = (title) => {
        document.title = title;
    };

    const updateFavicon = (path) => {
        let link = document.querySelector("link[rel~='icon']");
        if (!link) {
            link = document.createElement("link");
            link.rel = "icon";
            document.getElementsByTagName("head")[0].appendChild(link);
        }
        link.href = path;
    };

    return (
        <ThemeContext.Provider value={{ theme, vendorTheme, setTheme }}>
            <PrimeReactProvider value={{ pt }}>
                {children}
            </PrimeReactProvider>
        </ThemeContext.Provider>
    );
}
